module.exports = __webpack_public_path__ + "media/ngîan wói.601a3322.mp3";